import { useEffect, useState } from "react";
import { setConsentDefaultsDenied, updateConsent, loadGoogleTag } from "../util/gtag";

const STORAGE_KEY = "fit2clean_consent_v1";

const DEFAULTS = {
  necessary: true,
  analytics: false,
  marketing: false,
};

function safeParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function useConsent() {
  // ✅ niemals null: UI kann immer consent.analytics / consent.marketing lesen
  const [consent, setConsent] = useState(DEFAULTS);

  // ✅ Entscheidung heißt: es gibt einen gespeicherten Wert im Storage
  const [hasDecision, setHasDecision] = useState(false);

  useEffect(() => {
    // Default: alles denied (DSGVO safe-by-default)
    setConsentDefaultsDenied();

    const saved = safeParse(localStorage.getItem(STORAGE_KEY));
    if (saved && typeof saved === "object") {
      const merged = { ...DEFAULTS, ...saved, necessary: true };
      setConsent(merged);
      setHasDecision(true);

      updateConsent(merged);

      // ✅ gtag.js laden, wenn analytics ODER marketing erlaubt
      if (merged.analytics || merged.marketing) loadGoogleTag();
      return;
    }

    // keine Entscheidung gespeichert
    setConsent(DEFAULTS);
    setHasDecision(false);
  }, []);

  const saveConsent = (next) => {
    const merged = { ...DEFAULTS, ...next, necessary: true };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    setConsent(merged);
    setHasDecision(true);

    updateConsent(merged);

    // ✅ gtag.js laden, sobald irgendein Consent granted wurde
    if (merged.analytics || merged.marketing) loadGoogleTag();
  };

  const acceptAll = () => saveConsent({ analytics: true, marketing: true });
  const rejectAll = () => saveConsent({ analytics: false, marketing: false });

  // optional, aber manchmal praktisch (z.B. "Cookie-Auswahl zurücksetzen")
  const resetConsent = () => {
    localStorage.removeItem(STORAGE_KEY);
    setConsent(DEFAULTS);
    setHasDecision(false);
    setConsentDefaultsDenied();
    updateConsent(DEFAULTS);
  };

  return {
    consent,       // immer ein Objekt
    hasDecision,   // true sobald User einmal gespeichert hat
    acceptAll,
    rejectAll,
    saveConsent,
    resetConsent,
  };
}
